import React, { ReactElement, useState } from 'react';
import {
  Col, Input, Label, LoaderButton, Row,
} from 'idsk-react-components';
import { useNavigate } from 'react-router';
import { BackButton } from 'slovlex-idsk-react-components';
import { useClient } from '../../../../context/ClientStatusContext';
import { createTezaurus } from '../../../../client/tezaurus/tezaurusCreateClient';
import TezaurusCreate from '../../../../model/TezaurusCreate';
import routes from '../../../../routing/routes';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import './tezaurusCreateForm.scss';

const TezaurusCreateForm = (): ReactElement => {
  const [tezaurus, setTezaurus] = useState<TezaurusCreate>({ nazov: '' });
  const {
    wrapClient: createTezaurusClient,
    status: createTezaurusStatus,
  } = useClient(createTezaurus);
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  function updateNazov({ target }): void {
    setTezaurus({ nazov: target.value });
    clearFieldErrorMessage('nazov');
  }

  async function createTezaurusSubmit(event): Promise<void> {
    event.preventDefault();
    await createTezaurusClient(tezaurus);
    navigate(routes.tezaurus.admin.list);
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  }

  return (
    <form>
      <Row>
        <Col width="one-half">
          <Label htmlFor="nazov">Názov</Label>
        </Col>
      </Row>
      <Row className="tezaurus-create__nazov-input">
        <Col width="one-half">
          <Input
            key="nazov"
            type="text"
            maxLength={128}
            value={tezaurus.nazov}
            onChange={(event) => updateNazov(event)}
            error={getFieldErrorMessage && getFieldErrorMessage('nazov')}
          />
        </Col>
      </Row>
      <Row>
        <Col width="one-half">
          <LoaderButton
            className="tezaurus-create__create-button"
            loading={createTezaurusStatus.loading}
            onClick={event => createTezaurusSubmit(event)}
            size="large"
          >
            Vytvoriť
          </LoaderButton>
          <BackButton />
        </Col>
      </Row>
    </form>
  );
};

export default TezaurusCreateForm;
